import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-qa-type", "data-qa"]
const _hoisted_2 = { class: "gfu-toast__icon" }
const _hoisted_3 = { class: "_wbbw _flexcol _grow-1 _jc-c" }
const _hoisted_4 = {
  class: "_fw-eb",
  "data-qa": "toast-title"
}
const _hoisted_5 = {
  class: "gfu-bt--caption _tc--gray _my-0",
  "data-qa": "toast-message"
}
const _hoisted_6 = {
  key: 0,
  class: "gfu-bt--caption _flexaicntr _flexwrap _mt-1"
}
const _hoisted_7 = ["href", "onClick", "data-qa"]
const _hoisted_8 = { class: "gfu-toast__close" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_circle_icon = _resolveComponent("circle-icon")
  const _component_close_button = _resolveComponent("close-button")

  return (_openBlock(), _createElementBlock("div", {
    class: "gfu-toast",
    "data-qa-type": $options.qaType,
    onMouseenter: _cache[0] || (_cache[0] = (...args) => ($options.onToggleHoverState && $options.onToggleHoverState(...args))),
    onMouseleave: _cache[1] || (_cache[1] = (...args) => ($options.onToggleHoverState && $options.onToggleHoverState(...args))),
    "data-qa": `toast-notification:${$props.id}`
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_circle_icon, {
        icon: $options.icon,
        theme: $props.type
      }, null, 8 /* PROPS */, ["icon", "theme"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString($props.title), 1 /* TEXT */),
      _createElementVNode("p", _hoisted_5, _toDisplayString($props.description), 1 /* TEXT */),
      ($options.hasActions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.actionsMapped, (action) => {
              return (_openBlock(), _createElementBlock("a", {
                key: action.title,
                href: action.href,
                class: _normalizeClass(action.classes),
                onClick: $event => ($options.onAction($event, action)),
                "data-qa": `toast-button:${action.title}`
              }, _toDisplayString(action.title), 11 /* TEXT, CLASS, PROPS */, _hoisted_7))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      ($props.canClose)
        ? (_openBlock(), _createBlock(_component_close_button, {
            key: 0,
            duration: $props.duration,
            countdown: _ctx.shouldCountdown,
            qa: "toast-close-btn",
            onClose: $options.onClose
          }, null, 8 /* PROPS */, ["duration", "countdown", "onClose"]))
        : _createCommentVNode("v-if", true)
    ])
  ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1))
}